<template>
  <div class="overWrap">
    <div class="productionWrap">
      <div class="pHeader">
        <img :src="image" />
        <h4 :title="name">{{ name }}</h4>
      </div>
      <div class="pBody">
        <div class="pInner">
          <div class="pInfo">
            <div class="price">¥ {{ price }}</div>
            <div class="stock">
              <span>已有{{ sell_num }}人兑换</span>
              <span>库存{{ stock === 9999 ? stock : stock - sell_num }}</span>
            </div>
          </div>
          <van-button
            type="primary"
            :class="{ disabled: btnDisabled }"
            @click="exchangeBtnClicked"
            >兑换</van-button
          >
          <div
            v-if="month_buy"
            class="cornerMark"
            :class="{ disabled: buy_num == month_buy }"
          >
            每月限购{{ buy_num }}/{{ month_buy }}
          </div>
        </div>
        <div class="pDesc">
          <div>商品说明：</div>
          <div v-html="txt" />
        </div>
      </div>
    </div>
    <van-dialog
      v-model="showExchangeDialog"
      title="收货信息"
      :show-cancel-button="false"
      :show-confirm-button="false"
      width="4.57333rem"
      closeOnClickOverlay
    >
      <van-form
        ref="adressForm"
        class="exchangeForm"
        label-width="1rem"
        label-align="right"
      >
        <van-field
          v-model="form.name"
          name="name"
          :rules="rules.name"
          label="收货人姓名"
          placeholder="收货人姓名"
        >
        </van-field>
        <van-field
          v-model="form.provincesCity"
          name="provincesCity"
          :rules="rules.provincesCity"
          label="省市"
          placeholder="省市"
        ></van-field>
        <van-field
          v-model="form.address"
          name="address"
          :rules="rules.address"
          label="详细地址"
          placeholder="详细地址"
          rows="2"
          type="textarea"
        ></van-field>
        <van-field
          v-model="form.phone"
          name="phone"
          :rules="rules.phone"
          placeholder="联系手机号"
          label="联系手机号"
        ></van-field>
        <van-field name="rate" label=" " class="lastLine">
          <template #input>
            <p class="warnTips">提交后无法修改，请注意填写正确后再提交</p>
          </template>
        </van-field>
        <div class="submitBtnWrap">
          <van-button type="primary" @click="onSubmit">提交</van-button>
        </div>
      </van-form>
    </van-dialog>
  </div>
</template>
<script>
import mixins from '../../../mixins/exchangeShop/productioDetail.mixins';
export default {
  mixins: [mixins],
};
</script>
<style
  src="../../../style/exchange-shop/m/common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
::v-deep .van-dialog__header {
  margin-bottom: 83px;
}
.productionWrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 40px;
  .pHeader {
    width: 313px;
    // height: 360px;
    border: 2px solid #ffcc40;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 32px;
    padding: 20px 0;
    img {
      width: 270px;
      height: 270px;
    }
    h4 {
      height: auto;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
      line-height: 37px;
      // white-space: nowrap;
      text-align: left;
      overflow: hidden;
      // text-overflow: ellipsis;
      width: 270px;
      margin-top: 14px;
    }
  }
  .pBody {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    .pInner {
      width: 690px;
      height: 170px;
      background: #f7f7fa;
      border-radius: 8px;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 26px 30px;
      .pInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .price {
          font-size: 36px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #262626;
          line-height: 50px;
          margin-bottom: 12px;
          margin-top: 26px;
        }
        .stock {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          span {
            margin-right: 40px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      ::v-deep .van-button {
        width: 180px;
        height: 60px;
        background: #fd9b21;
        border-radius: 8px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        &.disabled {
          background-color: #d9d9d9;
          border-color: #d9d9d9;
        }
      }
      .cornerMark {
        width: auto;
        height: 40px;
        padding: 0 18px;
        background: #3b9aff;
        border-radius: 8px;
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 40px;
        position: absolute;
        top: 0;
        left: 0;
        &.disabled {
          background-color: #ccc;
        }
      }
    }
    .pDesc {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #878d99;
      line-height: 40px;
      margin-top: 26px;
    }
  }
}
.warnTips {
  color: #f53;
  font-size: 22px;
}
::v-deep .van-cell::after {
  display: none;
}
::v-deep .van-field__label span {
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 40px;
  white-space: nowrap;
}
::v-deep .van-field__control {
  height: 40px;
  font-size: 28px;
  line-height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 22px;
  box-sizing: content-box;
}
.lastLine {
  margin-bottom: 64px;
  ::v-deep .van-field__control {
    border: none;
    padding: 0;
  }
}
::v-deep .van-cell__title {
  padding-top: 22px;
}
::v-deep .van-form {
  padding: 0 16px;
}
::v-deep .van-field__error-message {
  font-size: 22px;
  padding-top: 8px;
}
.submitBtnWrap {
  text-align: center;
  margin-bottom: 54px;
  ::v-deep .van-button {
    margin: auto;
    width: 360px;
    height: 90px;
    border-radius: 8px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 45px;
  }
}
</style>
